import React from "react";

import { QuestionCircleFilled } from "@ant-design/icons";
import { Popover } from "antd";

import styles from "./styles.module.scss";

export interface ColumnTitleProps {
  title: string | React.ReactNode;
  helpText?: string | React.ReactNode;
}

export const ColumnTitle: React.FC<ColumnTitleProps> = (props) => {
  const { title, helpText } = props;

  const titleComp = <span className={styles.title}>{title}</span>;

  return helpText ? (
    <Popover placement="topLeft" content={helpText} trigger="hover">
      <QuestionCircleFilled className={styles.helpIcon} />
      {titleComp}
    </Popover>
  ) : (
    titleComp
  );
};
